module.exports = __webpack_public_path__ + "img/hexin@2x.81247591.png";